import Vue from "vue";
import AlertComponent from "./alert.vue";

let instance;
let AlertConstructor = Vue.extend(AlertComponent);
let initInstance = () => {
  instance = new AlertConstructor({
    el: document.createElement("div")
  });
  document.body.appendChild(instance.$el);
};

let Alert = path => {
  initInstance();
  return new Promise((resolve, reject) => {
    instance.path = path;
    instance.show = true;
    let success = instance.success;
    let close = instance.close;
    instance.success = () => {
      success();
      resolve("ok");
    };
    instance.close = () => {
      close();
      reject("no");
    };
  });
};
export default {
  install(Vue) {
    Vue.prototype.$alert = Alert;
  }
};
